const access_token = 'access_token';
const auth_response = 'auth_response';

export default {

  isMenuAllowed(requestPath){
    //return true; //for admin test only
    //access level not specified mean its public link
    if(!requestPath)
      return true;

    let auth_response=this.getAuthResponse();
    let access_path=null;//use localstorage to get the access path
    if(access_path!=undefined){
      access_path=JSON.parse(access_path);
      let isAllowed=false;
      if(access_path.indexOf(requestPath)>=0)
        isAllowed=true;
      return isAllowed;
    }
    else{
      return true;
    }
  },
  isLoggedIn() {
    const accessToken = this.getAccessToken();
    return !!accessToken;// && !isTokenExpired(accessToken);
  },
  logout() {
    this.clearAccessToken();
    this.clearAuthResponse();
    document.location.href='/login';
  },
  requireAuth(to, from, next) {
    window.scrollTo(0,0);
    let auth_response = sessionStorage[auth_response] || localStorage[auth_response];
    const acess_token =  sessionStorage[access_token] || localStorage[access_token];
    let isLoggedIn= !!acess_token;// && !isTokenExpired(accessToken);
    let expirationDateTime =new Date(parseInt(sessionStorage[access_token] || localStorage[access_token]));
    let dateTimeNow=new Date();
    if (!isLoggedIn || dateTimeNow>expirationDateTime) {
      localStorage.removeItem(access_token);
      sessionStorage.removeItem(access_token);
      next({
        path: '/login',//login path
        query: { redirect: to.fullPath }
      });
    }else {
      next();
    }
  },
  clearAccessToken() {
    localStorage.removeItem(access_token);
    sessionStorage.removeItem(access_token);
  },
  setAccessToken(access_tokend,persistent) {
    if (persistent) {
      localStorage[access_token] = access_tokend;
    } else {
      sessionStorage[access_token] = access_tokend;
    }
  },
  getAccessToken(){
    let auth_tokenStr = sessionStorage[access_token] || localStorage[access_token];
    if (auth_tokenStr)
      return `Bearer ${auth_tokenStr}`;
  },
  getAuthResponse() {
    let auth_response = sessionStorage[auth_response] || localStorage[auth_response];
    if (auth_response)
      return auth_response;
  },
  clearAuthResponse() {
    localStorage.removeItem(auth_response);
    sessionStorage.removeItem(auth_response);
  },
  setAuthResponse(auth_data,persistent) {
    if (persistent) {
      localStorage[auth_response] = auth_data;
    } else {
      sessionStorage[auth_response] = auth_data;
    }
  },
}
